import { Component, Optional } from '@angular/core';
import { DynamicFormService } from '@ntap/common';
import {
  BackendUploadService,
  ItemActionResult,
  ItemProvider,
  ItemView,
  ItemViewProviderDirective,
  NotificationService,
  ViewWindow
} from '@ntap/core';
import { PrimeNGButtonSaveCloseItemActionComponent } from '@ntap/primeng';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-save-close-deduplicated-agent-item',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class SaveCloseDeduplicatedAgentItemActionComponent extends PrimeNGButtonSaveCloseItemActionComponent {
  constructor(
    @Optional() protected override window: ViewWindow,
    protected override itemProvider: ItemProvider,
    protected override itemViewProvider: ItemViewProviderDirective<ItemView>,
    protected override formService: DynamicFormService,
    protected override notificationService: NotificationService,
    protected override backendUploadService: BackendUploadService
  ) {
    super(
      window,
      itemProvider,
      itemViewProvider,
      formService,
      notificationService,
      backendUploadService
    );
  }

  protected override doExecuteWithItem(
    item: any
  ): Observable<ItemActionResult> {
    const viewState: any = this.itemViewProvider.viewState;
    const selectedItems = viewState['$selected'];
    const selectedDeduplicatedIds = {
      $selectedDeduplicatedIds: selectedItems.map(
        (selectedItem: any) => selectedItem['en~agent~id'] // TODO provjeriti ako se moze koristiti ItemInfo da ne hardkodiramo dohvat id-a
      )
    };
    const itemResult = { ...item, ...selectedDeduplicatedIds };
    return super.doExecuteWithItem(itemResult);
  }
}
